import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo">
          PropertyTraining<span>.ai</span>
          <p>AI-powered property training</p>
        </div>
        <nav className="footer-links">
          <Link to="/courses">Courses</Link>
          <Link to="/about">About Us</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/refund-policy">Refund Policy</Link>
          <a href="mailto:amanda@propertytraining.ai">Contact</a>
        </nav>
        <p className="footer-legal">
          © 2026 PropertyTraining.ai · Registered in England & Wales<br/>
          <small>Not financial advice. All content is for educational purposes only.</small>
        </p>
      </div>
    </footer>
  );
}
